module.exports = __webpack_public_path__ + "img/sample-report-04@3x.f99ee63b.png";